import { useState } from 'react';

import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';
import { ErrorMessage } from '@iwoca/orion-ui';
import { Skeleton } from '@ui';
import { FormattedMessage } from 'react-intl';

import { buildRepaymentScheduleState } from '../../../../../modals/repaymentScheduleModal/RepaymentScheduleHelper';
import { RepaymentScheduleTable } from '../../../../../modals/repaymentScheduleModal/RepaymentScheduleTable';
import { isSelectedAmountValid } from '../../../../../ui/ChooseAmountInputWithSlider/isSelectedAmountValid';

export const SeeNewSchedule = ({
    drawdownAmount,
    selectedOffer
}: {
    drawdownAmount: number;
    selectedOffer: TFormalOffer;
}) => {
    const { data, isLoading, isError } = useDrawdownRepaymentSchedule({
        offerId: selectedOffer.offer_id!,
        drawdownAmount,
        enabled: isSelectedAmountValid(drawdownAmount, selectedOffer)
    });
    const [showSchedule, setShowSchedule] = useState(false);

    if (isLoading) return <Skeleton className="h-[20px] max-w-[100px]" />;
    if (isError)
        return (
            <ErrorMessage>
                <ErrorMessage.Icon />
                <ErrorMessage.Text>
                    <FormattedMessage
                        id="_.topup_choice.generic_error_message"
                        defaultMessage="Oops, it looks like something went wrong"
                    />
                </ErrorMessage.Text>
            </ErrorMessage>
        );

    const repaymentSchedule = buildRepaymentScheduleState(data);

    const openModal = () => {
        tracking.ampli.repaymentScheduleViewed();
        setShowSchedule(true);
    };

    return (
        <>
            <Modal
                isOpen={showSchedule}
                onClose={() => setShowSchedule(false)}
                closeIcon
                className="pt-2xl"
            >
                <RepaymentScheduleTable {...repaymentSchedule} />
            </Modal>
            <Button
                variant="tertiary"
                className="h-[30px] px-0"
                size="small"
                onClick={openModal}
            >
                <FormattedMessage
                    id="_.topup_choice.see_new_schedule"
                    defaultMessage="See new schedule"
                />
            </Button>
        </>
    );
};
